<script setup>

import Dialog from 'primevue/dialog';
import JeuDonnees from '@/components/generiques/JeuDonnees.vue';

const { jeuDonnees } = defineProps({
    jeuDonnees: Object
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['choix']);

function laisserJeuVide() {
    visible.value = false;
}

function choisir(choix) {
  visible.value = false;
  emit('choix', choix);
}

</script>

<template>
    <Dialog 
    v-model:visible="visible" 
    modal 
    header="Nouveau jeu de données">
        <div class="texte-introductif">
            <div>Initialisation des données du nouveau jeu : </div>
            <JeuDonnees 
                :jeu-donnees="jeuDonnees"/>
        </div>
        <div class="zone-boutons">
            <button 
                class="bouton" 
                autofocus
                @click="laisserJeuVide()">
                <i class="fa fa-square" />
                <div>Jeu de données vide</div>
            </button>
            <button 
                class="bouton" 
                @click="choisir('DUPLICATION')">
                <i class="fas fa-copy" />
                <div>Dupliquer un autre jeu de données</div>
            </button>
            <button 
                class="bouton" 
                @click="choisir('DERIVATION')">
                <i class="fas fa-share-alt" />
                <div>Dériver d'un autre jeu de données</div>
            </button>
        </div>
    </Dialog>
</template>

<style scoped>

.texte-introductif {
    margin-top: 2px;
    display: flex;
    align-items: center;
    gap: 20px;
}

.zone-boutons {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 20px;
}

.bouton {
    display: flex;
    align-items: center;
    gap: 5px;
}

</style>